module.exports = __webpack_public_path__ + "img/tournament.62e371f0.png";